import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Alert } from '@mui/material';

export function DocusignCompletionPage() {
  const [searchParams] = useSearchParams();
  const event = searchParams.get('event');
  const originalRedirectUrl = searchParams.get('redirectUrl');

  useEffect(() => {
    const messageData = {
      type: 'docusign_completion',
      event: event || 'signing_complete',
      redirectUrl: originalRedirectUrl,
    };

    // Send message to parent window
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(messageData, '*');
    }

    // Also send to opener for popup scenarios
    if (window.opener) {
      window.opener.postMessage(messageData, '*');
    }

    // Fallback redirect after delay
    setTimeout(() => {
      if (originalRedirectUrl) {
        if (window.parent && window.parent !== window) {
          try {
            window.parent.location.href = originalRedirectUrl;
          } catch (error) {
            // Continue with message approach if redirect fails
          }
        } else {
          window.location.href = originalRedirectUrl;
        }
      }
    }, 1000);
  }, [event, originalRedirectUrl]);

  return (
    <div className="via-purple-50 min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 p-4">
      <div className="flex flex-col items-center gap-4 p-8">
        <Alert severity="success">Document signed successfully!</Alert>
        <div className="text-sm text-gray-600">Redirecting you back...</div>
      </div>
    </div>
  );
}
